<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD" : "UPDATE" }} Config
      </h4>
      <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-3">General Information</vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div>
        <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>Device Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" name="name"
              :maxlength="50" icon-pack="feather" icon="icon-user" v-model="formData.deviceName" />
          </div>
        </div>
        <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>IOT Description</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" name="name"
              :maxlength="1000" icon-pack="feather" icon="icon-user" v-model="formData.description" />
          </div>
        </div>
        <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>IOT Type</label>
            <v-select :options="iotTypesList" placeholder="Search / Select IOT Type" v-model="iotTypeSelect" />
          </div>
        </div>
        <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>Store</label>
            <v-select :options="storesList" placeholder="Search / Select Store" v-model="storeSelect" />
          </div>
        </div>
        <!-- <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>Tank</label>
            <v-select :options="tanksList" placeholder="Search / Select Tank" multiple chips v-model="tankSelect" />
          </div>
        </div> -->
        <div class="vx-row px-4 pb-6">
          <div class="vx-col w-full">
            <label>Equipment</label>
            <v-select :options="equipmentsList" placeholder="Search / Select Equipment" v-model="equipmentSelect" />
          </div>
        </div>
      </div>
    </component>
    <div class="vx-row flex flex-wrap items-center">
      <vs-spacer />
      <div class="vx-col">
        <vs-button ref="saveEditButton" class="rounded-lg mr-3" color="success" type="border"
          @click="saveEditConfig">Save</vs-button>
        <vs-button class="rounded-lg mr-3" color="warning" type="border" @click="closeSidebar">Cancel</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import vSelect from "vue-select";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => { },
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  mounted() { },
  data() {
    return {
      formData: {
        accountId: 0,
        id: 0,
        deviceID: "",
        deviceName: "",
        iotType: "",
        iotTypeDesc: "",
        iotTypeBrand: "",
        iotTypeID: 0,
        name: "",
        description: "",
        storeID: 0,
        tankID: 0,
        equipmentID: 0,
        equipment: "",
        store: "",
        tank: "",
      },



      integrationData: [],
      verificationTypeData: [],

      selectedVerification: 0,
      selectedIntegration: 0,

      storesList: [],
      storeSelect: {},

      iotTypesList: [],
      iotTypeSelect: {},

      tanksList: [],
      tankSelect: {},

      equipmentsList: [],
      equipmentSelect: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  mounted() {
    this.getIoTTypes();
    this.getStores();
    this.getTanks();
    this.getEquipments();
  },
  watch: {
    isSidebarActive(val) {
      var self = this;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        // this.$validator.reset();
        // this.getAccountsList();
      } else {
        self.formData.accountId = this.data.accountId;
        self.formData.id = this.data.id;
        self.formData.deviceID = this.data.deviceID;
        self.formData.deviceName = this.data.deviceName;
        self.formData.iotType = this.data.iotType;
        self.formData.iotTypeDesc = this.data.iotTypeDesc;
        self.formData.iotTypeBrand = this.data.iotTypeBrand;
        self.formData.iotTypeID = this.data.iotTypeID;
        self.formData.name = this.data.name;
        self.formData.description = this.data.description;
        self.formData.storeID = this.data.storeID;
        self.formData.tankID = this.data.tankID;
        self.formData.equipmentID = this.data.equipmentID;
        self.formData.equipment = this.data.equipment;
        self.formData.store = this.data.store;
        self.formData.tank = this.data.tank;

        setTimeout(() => {
          self.iotTypeSelect = self.iotTypesList.find(item => item.value === self.data.iotTypeID) || {};
          self.storeSelect = self.storesList.find(item => item.value === self.data.storeID) || {};
          self.tankSelect = self.tanksList.find(item => item.value === self.data.tankID) || {};
          self.equipmentSelect = self.equipmentsList.find(item => item.value === self.data.equipmentID) || {};
        }, 100);

      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    closeSidebar() {
      this.initValues();
      this.isSidebarActiveLocal = false;
    },
    initValues() {
      this.getIoTTypes();
      this.getStores();
      this.getTanks();
      this.getEquipments();
      this.formData.accountId = 0;
      this.formData.id = 0;
      this.formData.deviceID = "";
      this.formData.deviceName = "";
      this.formData.iotType = "";
      this.formData.iotTypeDesc = "";
      this.formData.iotTypeBrand = "";
      this.formData.iotTypeID = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.storeID = 0;
      this.formData.tankID = 0;
      this.formData.equipmentID = 0;
      this.formData.equipment = "";
      this.formData.store = "";
      this.formData.tank = "";
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },

    saveEditConfig() {
      var self = this;
      var typeId = self.iotTypeSelect.value ? self.iotTypeSelect.value : 0;
      var storeId = self.storeSelect.value ? self.storeSelect.value : 0;
      var equipmentId = self.equipmentSelect.value ? self.equipmentSelect.value : 0;

      // var list = self.tankSelect.map(item => item.value);

      // var tankId = list.length == 1 ? list[0] : 0;

      var obj = {
        id: self.formData.id,//nit
        deviceName: self.formData.deviceName,//string
        iotTypeId: typeId || 0,//int
        name: self.formData.deviceName,//string
        description: self.formData.description,///string
        storeID: storeId || 0,//int
        tankID: 0,//int
        tankIDs: "N/A",//string
        equipmentID: equipmentId || 0//int
      };
      self.showLoadingOnElement("saveEditButton", 0.65, "radius");

      var onSuccess = (response) => {
        self.closeSidebar();
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: `Saved`,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-save",
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.saveEditButton.$el);
      };
      if(self.formData.id > 0){
        var id = self.formData.id;
        self.$ajaxPut(self, "FAMSIoT/" + id, obj, onSuccess, onFinally);
      } else {
        self.$ajaxPost(self, "FAMSIoT", obj, onSuccess, onFinally);
      }
    },
    getStores(){
      const self = this;
        var onSuccess = function(response) {
          self.storesList = response.data.map(function(item) {
            return { label: item.name, value: item.id };

          });
        };
        var onFinally = function() {
          // self.$vs.loading.close(self.$refs.categorySelect.$el);
        };
        self.$ajaxGet(self, "Stores/GetStoredropdown", onSuccess, onFinally);
    },
    getIoTTypes(){
      const self = this;
        var onSuccess = function(response) {
          self.iotTypesList = response.data.map(function(item) {
            return { label: item.name, value: item.id };

          });
        };
        var onFinally = function() {
          // self.$vs.loading.close(self.$refs.categorySelect.$el);
        };
      self.$ajaxGet(self, "FAMSIoT/GetIotTypedropdown", onSuccess, onFinally);
    },
    getTanks(){
      const self = this;
        var onSuccess = function(response) {
          self.tanksList = response.data.map(function(item) {
            return { label: item.name, value: item.id };

          });
        };
        var onFinally = function() {
          // self.$vs.loading.close(self.$refs.categorySelect.$el);
        };
      self.$ajaxGet(self, "Tanks/GetTankdropdown", onSuccess, onFinally);
    },
    getEquipments(){
      const self = this;
        var onSuccess = function(response) {
          self.equipmentsList = response.data.map(function(item) {
            return { label: item.name, value: item.id };

          });
        };
        var onFinally = function() {
          // self.$vs.loading.close(self.$refs.categorySelect.$el);
        };
      self.$ajaxGet(self, "Equipments/GetEquipmentDropDown", onSuccess, onFinally);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
